import React from "react"

import Paragraph from "../../design-system/paragraph"
import { classNames } from "../../utils/class-names"
import { abbreviatedMonthFormat } from "../../utils/dates"
import * as styles from "./index.module.scss"

export const separator = <span className={styles.separator}>●</span>

interface BlogMetaDataProps {
  author?: string
  minutesOfReading?: number
  updatedAt?: string
  className?: string
}

const BlogMetadata: React.FC<BlogMetaDataProps> = ({
  author,
  minutesOfReading,
  updatedAt,
  className,
}) => {
  return (
    <Paragraph
      data-testid="PostMetaData"
      variant="3"
      className={classNames(styles.container, className)}
    >
      {author && (
        <>
          <span className={styles.author}>By {author}</span>
          {separator}
        </>
      )}
      {minutesOfReading && (
        <>
          <span>{minutesOfReading} min. read</span>
          {separator}
        </>
      )}
      {updatedAt && <span>{abbreviatedMonthFormat(updatedAt)}</span>}
    </Paragraph>
  )
}
export default BlogMetadata
